import React from 'react';

const Stack = (props) => {
    const classes = `d-flex${props.className ? ' ' + props.className : ''}`;
    return (
        <div className={classes} style={props.style}>
            {props.children}
        </div>
    );

};

export default Stack;

